import api from '@/lib/api';
import type {
  ApiResponse,
  Campus,
  CampusDashboardResponse,
  CampusOccupancyResponse,
  CreateCampusRequest,
  UpdateCampusRequest,
  CampusListQuery,
  BulkCreateCampusesRequest,
  BulkCreateResult,
  PaginationMeta,
} from '@amuster/types';

export const campusService = {
  list(query?: CampusListQuery) {
    return api.get<ApiResponse<Campus[]> & { meta: PaginationMeta }>('/campuses', { params: query });
  },

  create(data: CreateCampusRequest) {
    return api.post<ApiResponse<Campus>>('/campuses', data);
  },

  getById(id: string) {
    return api.get<ApiResponse<Campus>>(`/campuses/${id}`);
  },

  update(id: string, data: UpdateCampusRequest) {
    return api.put<ApiResponse<Campus>>(`/campuses/${id}`, data);
  },

  remove(id: string) {
    return api.delete<ApiResponse<null>>(`/campuses/${id}`);
  },

  getDashboard(id: string) {
    return api.get<ApiResponse<CampusDashboardResponse>>(`/campuses/${id}/dashboard`);
  },

  getOccupancy(id: string) {
    return api.get<ApiResponse<CampusOccupancyResponse>>(`/campuses/${id}/occupancy`);
  },

  bulkCreate(data: BulkCreateCampusesRequest) {
    return api.post<ApiResponse<BulkCreateResult>>('/campuses/bulk', data);
  },
};
